import { ConfigClient } from '@/modules/client-config/domain/models/ConfigClient'
import { UpdateConfigClient } from '@/modules/client-config/domain/models/UpdateConfigClient'

import { axios, Response } from '../index'

export default async function bodyConfig(
  content: UpdateConfigClient
): Response<ConfigClient> {
  return axios.put(`/v1/body-config`, content)
}
